module.exports = __webpack_public_path__ + "static/media/hierarchy_central.2efc5e9e.svg";